import { apiFetch } from '#imports'
import { useAuthStore } from '../stores/authStore'
import type { actionResponse } from '../types/cmsTypes'

export const login = async (email: string, password: string): Promise<actionResponse> => {
  const authstore = useAuthStore()
  const result = await apiFetch(`/api/login`, {
    method: 'POST',
    body: JSON.stringify({ email, password })
  })
  if (!result.status_ok) {
    authstore.setAuthStatus(false)
    authstore.setToken(null)
    return result
  }
  if (!(result.data as { token?: string })) {
    return { status_ok: false, message: 'Nie udało się pobrać tokena' }
  }
  authstore.setToken((result.data as { token: string }).token)
  authstore.setAuthStatus(true)
  return { status_ok: true }
}

export const checkAdminSession = async (): Promise<actionResponse> => {
  const authstore = useAuthStore()
  const result = await apiFetch(`/api/auth/check`, { method: 'GET' })
  if (!result.status_ok) {
    authstore.setAuthStatus(false)
    authstore.setToken(null)
  }
  return result
}

export const logout = async (): Promise<actionResponse> => {
  const authstore = useAuthStore()
  if (!authstore.token) {
    return { status_ok: false, message: 'nie masz tokena' }
  }
  const result = await apiFetch(`/api/logout`, { method: 'POST' })
  if (result.status_ok) {
    authstore.setToken(null)
    authstore.setAuthStatus(false)
  }
  return result
}
